import * as angular from 'angular';
import { UpdatesService } from 'modules/core/UpdatesService';
import { ConfigurationsService } from 'modules/application/misc/ConfigurationsService';
import { MonitoringInitializers } from './monitoring/MonitoringInitializers';
import { ContextProcessorService } from './ContextProcessorService';
import { InitializeUserService } from './InitializeUserService';
export const core = angular
    .module('core', [])
    .service('UpdatesService', UpdatesService)
    .service('ConfigurationsService', ConfigurationsService)
    .service('ContextProcessorService', ContextProcessorService)
    .service('InitializeUserService', InitializeUserService)
    .config(['$httpProvider', function ($httpProvider) {
        // Prevent cache on IE
        if (!$httpProvider.defaults.headers.common) {
            $httpProvider.defaults.headers.common = {};
        }
        $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
        $httpProvider.defaults.headers.common.Pragma = 'no-cache';
        $httpProvider.defaults.headers.common['If-Modified-Since'] = '0';
    }])
    .run(['$window', '$q', '$http', function ($window, $q, $http) {
        //Set Promise of type 'await' to be a Promise of type $q
        $window.Promise = $q;
        $http.defaults.headers.common['Accept-Language'] = 'pt-BR, pt-br, pt;q=0.8, en-US;q=0.5, en;q=0.4, es;q=0.3';
        return MonitoringInitializers.init();
    }]).name;
